import React, { FC } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import { SectionLabel } from './SectionCard';
import { IconCross } from '../../utils/icons';

const BLACK_FAMILY = 'CircularStdBlack, Helvetica, Arial, sans-serif';

interface Props {
  open: boolean;
  onClose: () => void;
  name?: string;
  src?: string;
}

/** Video-intro overlay: 16px radius (matching the cards), labelled close, 16:9 plate. */
const VideoIntroModal: FC<Props> = ({ open, onClose, name, src }) => (
  <Modal open={open} onClose={onClose} className="flex items-center justify-center p-4 sm:p-8">
    <Box
      className="w-full max-w-[880px] bg-surface rounded-2xl overflow-hidden outline-none"
      style={{ boxShadow: 'var(--sh-2)' }}
    >
      <Box className="flex items-center justify-between gap-4 px-5 py-4 border-b border-border-token">
        <Box className="flex flex-col gap-1 min-w-0">
          <SectionLabel>Video introduction</SectionLabel>
          <Typography
            className="truncate"
            sx={{ fontFamily: BLACK_FAMILY, fontSize: 16, lineHeight: 1.2, color: 'var(--text)' }}
          >
            {name}
          </Typography>
        </Box>
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          className="w-[34px] h-[34px] rounded-full flex items-center justify-center hover:bg-surface-2 shrink-0"
        >
          <IconCross width={17} height={17} stroke="var(--text-2)" />
        </button>
      </Box>
      <Box className="bg-rail flex items-center justify-center" style={{ aspectRatio: '16 / 9' }}>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video src={src} className="w-full h-full" controls controlsList="nodownload" />
      </Box>
    </Box>
  </Modal>
);

export default VideoIntroModal;
